import Vue from 'vue'
import Vuex from 'vuex'

import configStore from './store'
import { EnlaceExterno, EnlaceExternoDocumento, Documento, Operacion, TipoDocumento, TipoTramite, Dependencia, DocGenerado, Plantilla, FirmaToken } from '@/js/api/tramite'
import {Regulation,RegulationTipo, RegulationFile, RegulationSincResult} from '@api/normatividad'
Vue.use(Vuex)
import stateDocumento from './modules/tramite/documento'

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  modules : {
    enlace_externo           : EnlaceExterno.getStore(),
    enlace_externo_documento : EnlaceExternoDocumento.getStore(),
    regulation               : Regulation.getStore(),
    regulation_tipo          : RegulationTipo.getStore(),
    regulation_file          : RegulationFile.getStore(),
    regulation_sinc_result   : RegulationSincResult.getStore(),
    dependencia              : Dependencia.getStore(),
    tramite_documento        : Documento.setStore(stateDocumento).getStore(),
    tramite_operacion        : Operacion.getStore(),
    tramite_tipo_documento   : TipoDocumento.getStore(),
    tramite_tipo_tramite     : TipoTramite.getStore(),
    tramite_doc_generado     : DocGenerado.getStore(),
    tramite_plantilla        : Plantilla.getStore(),
    tramite_firma_token      : FirmaToken.getStore(),
    global                   : configStore
  },
  strict : debug,
})
